import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { ensureSafeComponent } from '@embroider/util';
import Component from '@glimmer/component';

interface HotelMarketInsightListsListEventsSignature {
  Args: {
    allEvents: unknown;
    eventItemComponent: unknown;
    hasLimitedHeight: unknown;
    highlightMarker: unknown;
  };
}

export default class HotelMarketInsightListsListEvents extends Component<HotelMarketInsightListsListEventsSignature> {
  listId = `events-list-${guidFor(this)}`;

  // @ts-expect-error: Incorrect type
  @action mouseOutEvent(eventObject): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.highlightMarker(eventObject.id, false);
  }

  // @ts-expect-error: Incorrect type
  @action mouseOverEvent(eventObject): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.highlightMarker(eventObject.id, true);
  }

  <template>
    <ul
      class={{if @hasLimitedHeight "event-list--max-height"}}
      id={{this.listId}}
    >
      {{! @glint-expect-error: Incorrect type }}
      {{#each @allEvents as |event|}}
        {{#if @highlightMarker}}
          <li
            class="event-item event-item__hover flex flex-row"
            {{on "mouseenter" (fn this.mouseOverEvent event)}}
            {{on "mouseleave" (fn this.mouseOutEvent event)}}
          >
            {{component (ensureSafeComponent @eventItemComponent) event=event}}
          </li>
        {{else}}
          <li class="event-item flex flex-row">
            {{component (ensureSafeComponent @eventItemComponent) event=event}}
          </li>
        {{/if}}
      {{/each}}
    </ul>
  </template>
}
